import * as React from 'react';
import { classNames, MakeEgdsSizingLength } from 'uitk-react-utils';
import styles from './uitk-sheet.css';
import UitkSheetContext from './uitk-sheet-context.esm.js';

var getClassNameList = classNames.bind(styles);
var UitkSheetContent = function (props) {
    var _a;
    var children = props.children, className = props.className, contentDomRef = props.contentDomRef, fullSheetContentMaxWidth = props.fullSheetContentMaxWidth, _b = props.padded, padded = _b === void 0 ? true : _b;
    var baseClassName = 'uitk-sheet-content';
    var sheetContext = React.useContext(UitkSheetContext);
    var posStyle = (sheetContext.maxHeight && {
        maxBlockSize: "".concat(MakeEgdsSizingLength(sheetContext.maxHeight))
    }) ||
        undefined;
    var sheetContentClasses = getClassNameList(baseClassName, className, (_a = {},
        _a["".concat(baseClassName, "-padded")] = padded,
        _a), fullSheetContentMaxWidth && "".concat(baseClassName, "-").concat(fullSheetContentMaxWidth));
    return (React.createElement("div", { className: sheetContentClasses, ref: contentDomRef, style: posStyle }, children));
};
UitkSheetContent.displayName = 'UitkSheetContent';

export { UitkSheetContent };
